module.exports = __webpack_public_path__ + "static/media/factory_top.ee725dcd.png";